module.exports = __webpack_public_path__ + "img/scoundrel.c6e2df4b.png";